import React from 'react'
import { Toaster } from 'react-hot-toast'
import LoginNavigation from './WebView/Navigation/LoginNavigation/LoginNavigation'
import { getCahbookUser } from './Storage/Storage'
import Panel from './Components/Panel/Panel'

function App() {
  const user = getCahbookUser()


  return (
    <>
      <Toaster />
      {
        user ? <Panel /> : <LoginNavigation />
      }
    </>


  )
}

export default App
